require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-glennsl-infinite-jest.json") })
        }
      }, "path---package-unpublished-glennsl-infinite-jest");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-glennsl-infinite-jest!./.cache/json/package-unpublished-glennsl-infinite-jest.json
// module id = 941
// module chunks = 231608221292675